import { render, staticRenderFns } from "./AmenitySelector.vue?vue&type=template&id=3b7585c7&scoped=true&"
import script from "./AmenitySelector.vue?vue&type=script&lang=js&"
export * from "./AmenitySelector.vue?vue&type=script&lang=js&"
import style0 from "./AmenitySelector.vue?vue&type=style&index=0&id=3b7585c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7585c7",
  null
  
)

export default component.exports